import { Avatar, Card, Typography } from "antd";
import { EnumeratorInterface } from "api/enumerator/Profile/dto";
import maleProfile from "assets/maleProfile.svg";
import femaleProfile from "assets/femaleProfile.svg";
import otherProfile from "assets/otherProfile.svg";

const { Title, Text } = Typography;

interface AvatarProfileProps {
  user: EnumeratorInterface;
}

export const AvatarProfile = ({ user }: AvatarProfileProps) => {
  // Determine the appropriate avatar based on the user's gender
  const getAvatarSrc = () => {
    if (user.gender === "male") {
      return maleProfile;
    } else if (user.gender === "female") {
      return femaleProfile;
    } else {
      return otherProfile;
    }
  };

  return (
    <Card>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Avatar src={getAvatarSrc()} size={150} />
        <Title level={4} style={{ marginBottom: 0, marginTop: "18px" }}>
          {user?.firstName} {user?.lastName}
        </Title>
        <Text type="secondary">{user?.email}</Text>
      </div>
    </Card>
  );
};
